export const formatGrade = (grade: number | null, isStudent: boolean): string => {
  if (isStudent) return "Studentas";
  return grade !== null ? String(grade) : "";
};

export const formatGradeWithSuffix = (grade: number | null, isStudent: boolean): string => {
  if (isStudent) return "Studentas";
  return grade !== null ? `${grade} kl.` : "";
};
